import useSWR from 'swr'

import { useCurrentTenantConfig } from '../../utils/tenants'
import { FetchResponse } from '../fetchResponse'
import { FetchResult } from '../fetchResult'
import { fetchJson } from '../fetchers'
import { Theme } from './model'

export function useTheme(): FetchResult<Theme> {
  const { tenantId } = useCurrentTenantConfig()
  const { data, isLoading, error, mutate } = useSWR<FetchResponse<Theme>>(
    !tenantId ? null : `/config/theme`,
    fetchJson,
  )

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
  }
}
